export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
export const SET_SUBSCRIPTIONS = "SET_SUBSCRIPTIONS";
export const SET_SUBSCRIPTIONS_LOADING = "SET_SUBSCRIPTIONS_LOADING";
export const SET_SUBSCRIPTIONS_ERROR = "SET_SUBSCRIPTIONS_ERROR";
export const GET_TOPUP_PLANS = "GET_TOPUP_PLANS";
export const SET_TOPUP_PLANS = "SET_TOPUP_PLANS";
export const SET_TOPUP_PLANS_LOADING = "SET_TOPUP_PLANS_LOADING";
export const SET_TOPUP_PLANS_ERROR = "SET_TOPUP_PLANS_ERROR";
export const GET_USERS_TOKENS_UTILIZATION = "GET_USERS_TOKENS_UTILIZATION";
export const SET_USERS_TOKENS_UTILIZATION = "SET_USERS_TOKENS_UTILIZATION";
export const SET_USERS_BALANCE_LOADING = "SET_USERS_BALANCE_LOADING";
export const SET_USERS_BALANCE_ERROR = "SET_USERS_BALANCE_ERROR";

export const getSubscriptions = () => {
    return {
        type: GET_SUBSCRIPTIONS,
        payload: null
    }
};

export const setSubscriptions = (subscriptions: any[]) => {
    return {
        type: SET_SUBSCRIPTIONS,
        payload: subscriptions
    }
};

export const setSubscriptionsLoading = (loading: boolean) => {
    return {
        type: SET_SUBSCRIPTIONS_LOADING,
        payload: loading
    }
};

export const setSubscriptionsError = (error: string | null) => {
    return {
        type: SET_SUBSCRIPTIONS_ERROR,
        payload: error
    }
};

export const getUsersTokensUtilization = () => {
    return {
        type: GET_USERS_TOKENS_UTILIZATION,
        payload: null
    }
};


export const setUsersTokensUtilization = (usersTokensUtilization: any) => {
    return {
        type: SET_USERS_TOKENS_UTILIZATION,
        payload: usersTokensUtilization
    }
};

export const setUsersBalanceLoading = (loading: boolean) => {
    return {
        type: SET_USERS_BALANCE_LOADING,
        payload: loading
    }
};

export const setUsersBalanceError = (error: string | null) => {
    return {
        type: SET_USERS_BALANCE_ERROR,
        payload: error
    }
};

export const getTopupPlans = () => {
    return {
        type: GET_TOPUP_PLANS,
        payload: null
    }
};

export const setTopupPlans = (topupPlans: any[]) => {
    return {
        type: SET_TOPUP_PLANS,
        payload: topupPlans
    }
};

export const setTopupPlansLoading = (loading: boolean) => {
    return {
        type: SET_TOPUP_PLANS_LOADING,
        payload: loading
    }
};

export const setTopupPlansError = (error: string | null) => {
    return {
        type: SET_TOPUP_PLANS_ERROR,
        payload: error
    }
};
